module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose with-attribution"
  }, [_c('blockquote', {
    staticClass: "prose with-attribution"
  }, [_c('div', {
    staticClass: "paragraph-and-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first epigraph-content"
  }, [_vm._v("“Or what woman, having ten silver coins, if she loses one coin, does not light a lamp and sweep the house and seek diligently until she finds it?”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-attribution blockquote-position-last"
  }, [_c('span', {
    staticClass: "case-upper"
  }, [_vm._v("LUKE 15:8")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 69
// module chunks = 0